import React from 'react'
import Pipeline from "./Pipeline";
import QuadrantDetail from './QuadrantDetail';

const Quadrant = ({
  canPage, 
  cansLenght, 
  groupedCans, 
  isSingleModule,
  generador, 
  controlType, 
  userLevel, 
  modulo_id, 
  translate,
  statusGeneradorManual, 
  selectedCenter,
  dragDropEnabled = false,
  canEditLayout = false,
  draggedCanKey = null,
  dragOverCanKey = null,
  isDraggingCanLayout = false,
  onCanDragStart,
  onCanDragEnd,
  onCanDragOver,
  onCanMove,

}) => {


  return (
    <div className="cans-carousel">
        <div
            className="cans-inner"
            style={{ transform: `translateX(-${canPage * 100}%)`,}}
        >
            {groupedCans.map((group, pageIndex) => (
                <div key={pageIndex} className="cans-page">
                    {group.map((can, id) => {

                      const idCan = can?.can?.match(/\d+$/)?.[0] || `row-${id}`;
                      const canKey = String(can?.can ?? `page-${pageIndex}-can-${id}`);

                      return(
                        <div key={can.can_id} 
                          className={`can-card ${draggedCanKey === canKey ? "is-dragging" : ""} ${dragOverCanKey === canKey ? "is-drag-target" : ""}`}
                          draggable={canEditLayout}
                          onDragStart={() => onCanDragStart?.(canKey)}
                          onDragEnd={() => onCanDragEnd?.()}
                          onDragOver={(event) => {
                            if (!canEditLayout) {
                              return;
                            }

                            event.preventDefault();
                            onCanDragOver?.(canKey);
                          }}
                          onDrop={(event) => {
                            if (!canEditLayout) {
                              return;
                            }

                            event.preventDefault();
                            onCanMove?.(draggedCanKey, canKey);
                            onCanDragEnd?.();
                          }}
                            // className="can-card"
                        >
                            {/*  Bombas delegadas al componente Pipeline */}
                            <Pipeline 
                              cansLenght={cansLenght} 
                              translate={translate} 
                              statusGenerator={can.generator === null ? statusGeneradorManual : can.generator }  
                              bombas={can.bombas} 
                              isSingleModule={isSingleModule} 
                              generador={generador} 
                              controlType={controlType} 
                              userLevel ={userLevel} 
                              idxCan={idCan} 
                              modulo_id={modulo_id} 
                              selectedCenter={selectedCenter} 
                              pressureHysteresis={can?.presion_histeresis === true}
                              suspendHeavyContent={isDraggingCanLayout}
                              dragDropEnabled={dragDropEnabled}
                            />
                            <QuadrantDetail translate={translate} can={can} selectedCenter={selectedCenter}/>
                        </div>
                      )
                    })}
                </div>
            ))}
        </div>
    </div>
  )
}

export default Quadrant